<!-- Header -->
<header class="site-header">
    <div class="container header-main">
        <!-- Logo -->
        <a href="/" class="logo">
            <img src="images/dealszo-logo.svg" alt="Dealszo Logo" class="logo-img" width="160" height="40">
        </a>

        <!-- Navigation -->
        <nav class="v1-nav">
            <a href="/stores/">Stores</a>
            <a href="/categories/">Categories</a>
            <a href="/deals/">Best Deals</a>
            <a *ngIf="ongoingSeasonalEevent && ongoingSeasonalEevent.SeasonalId > 0"
                href="/seasonal/{{ongoingSeasonalEevent.SeasonalSEOName}}/">{{ongoingSeasonalEevent.SeasonalName}}</a>
            <a href="https://blog.dealszo.com">Blog</a>
        </nav>

        <!-- Search -->
        <div class="search-container" [class.is-open]="showDropdown">
            <div class="search-box">
                <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                <input type="search" id="site-search" placeholder="What are you looking for today?" autocomplete="off"
                    [value]="searchQuery" (focus)="showDropdown = true" (input)="updateSearchQuery($event)"
                    (keyup.enter)="onSearchEnter()">
            </div>
            <!-- Search Dropdown -->
            <div class="search-dropdown" *ngIf="showDropdown">
                <div class="dropdown-section" *ngIf="topBrands.length && searchQuery.trim().length < 4">
                    <div class="section-title">
                        Trending Stores
                        <a href="/stores/">See All</a>
                    </div>
                    <div class="dropdown-grid">
                        @for (brand of topBrands; track brand.StoreId) {
                        <a class="dropdown-item" [href]="'/' + brand.SeoName + '-coupons/'">
                            <div class="item-info">
                                <span class="item-name">
                                    {{ brand.StoreName }}
                                </span>
                            </div>
                        </a>
                        }
                    </div>
                </div>
                <div class="dropdown-section"
                    *ngIf="searchedBrands && searchedBrands.length > 0 && searchQuery.trim().length >= 4">
                    <div class="section-title">
                        Search Result - Stores
                        <a href="/stores/">See All</a>
                    </div>
                    <div class="dropdown-grid">
                        @for (brand of searchedBrands; track brand.StoreId) {
                        <a class="dropdown-item" [href]="'/' + brand.SeoName + '-coupons/'">
                            <div class="item-info">
                                <span class="item-name">
                                    {{ brand.StoreName }}
                                </span>
                                <span class="item-meta">
                                    {{ 'Best offers available' }}
                                </span>
                            </div>
                        </a>
                        }
                    </div>
                </div>
                <div class="dropdown-section"
                    *ngIf="searchedCategories && searchedCategories.length > 0 && searchQuery.trim().length >= 4">
                    <div class="section-title">
                        Search Result - Categories
                        <a href="/categories/">See All</a>
                    </div>
                    <div class="dropdown-grid">
                        @for (category of searchedCategories; track category.CategoryId) {
                        <a class="dropdown-item" [href]="'/coupons/' + category.CategorySEOName + '/'">
                            <div class="item-info">
                                <span class="item-name">
                                    {{ category.CategoryName }}
                                </span>
                            </div>
                        </a>
                        }
                    </div>
                </div>
                <!-- No Results -->
                <div class="dropdown-section no-results"
                    *ngIf="searchQuery.length >= 4 && (searchedBrands.length === 0 && searchedCategories.length === 0)">
                    No result found
                </div>
            </div>
        </div>

        <!-- Actions -->
        <div class="header-actions">
            <a href="/add-offer/" class="header-submit">Submit Deal</a>
            <button id="mobile-search-btn" class="mobile-search-btn" aria-label="Search">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
            </button>
            <button id="mobile-menu-btn" class="mobile-toggle" aria-label="Menu">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
            </button>
        </div>
    </div>

    <!-- Mobile Menu Backdrop -->
    <div id="mobile-backdrop" class="mobile-backdrop"></div>

    <!-- Mobile Menu -->
    <div id="mobile-menu" class="mobile-menu">
        <!-- Mobile Search -->
        <div class="mobile-search-wrapper">
            <div class="mobile-menu-search">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                <input type="search" id="mobile-search-input" placeholder="Search stores, coupons..." autocomplete="off"
                    [value]="searchQuery" (focus)="showDropdown = true" (input)="updateSearchQuery($event)"
                    (keyup.enter)="onSearchEnter()">
            </div>
            <!-- Mobile Search Dropdown -->
            <div class="mobile-search-dropdown" *ngIf="showDropdown">
                <div class="msd-section" *ngIf="topBrands.length && searchQuery.length == 0">
                    <div class="msd-header">Trending Searches</div>
                    @for (brand of topBrands; track brand.StoreId) {
                    <a [href]="'/' + brand.SeoName + '-coupons/'" class="msd-item"
                        [attr.data-query]="brand.StoreName + ' coupons'"><span>{{ brand.StoreName }} Coupons</span></a>
                    }
                </div>
                <div class="msd-section" id="msd-results-section"
                    *ngIf="searchedBrands.length && searchQuery.length >= 4">
                    <div class="msd-header">Results</div>
                    @for (brand of searchedBrands; track brand.StoreId) {
                    <a [href]="'/' + brand.SeoName + '-coupons/'" class="msd-item"
                        [attr.data-query]="brand.StoreName + ' coupons'"><span>{{ brand.StoreName }} Coupons</span></a>
                    }
                </div>
                <div class="msd-section" id="msd-results-section"
                    *ngIf="searchedCategories.length && searchQuery.length >= 4">
                    <div class="msd-header">Results</div>
                    @for (category of searchedCategories; track category.CategoryId) {
                    <a [href]="'/coupons/' + category.CategorySEOName + '/'" class="msd-item"
                        [attr.data-query]="category.CategoryName + ' coupons'"><span>{{ category.CategoryName }}
                            Coupons</span></a>
                    }
                </div>
            </div>
        </div>
        <a href="/stores/">Stores</a>
        <a href="/categories/">Categories</a>
        <a href="https://blog.dealszo.com">Blog</a>
        <hr>
        <a href="/add-offer/">Submit Deal</a>
        <a href="/freeshipping/">Free Shipping</a>
        <a href="/clearance/">Clearance</a>
    </div>
</header>

<!-- Pages -->
<main class="min-h-screen">
    <router-outlet></router-outlet>
</main>

<!-- Subscribe -->
<div class="subscribe-bar">
    <div class="container">
        <div class="subscribe-content">
            <div class="sub-icon">
                <span class="g-logo">D</span>
            </div>
            <div class="sub-text">
                <h3>Subscribe Now</h3>
                <p>Stay Updated with the Best Coupons & Offers</p>
            </div>
        </div>
        <form class="sub-form">
            <div class="input-group">
                <svg class="icon-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <input type="email" class="form-control" autocomplete="off" [(ngModel)]="subscriberEmail" name="email"
                    required #email="ngModel" placeholder="Enter Email">
            </div>
            <button type="submit" class="sub-btn">SUBSCRIBE</button>
        </form>
    </div>
</div>

<!-- Footer -->
<footer class="new-footer">
    <div class="footer-top">
        <div class="container">
            <div class="footer-top-grid">
                <!-- Brand -->
                <div class="footer-brand">
                    <p class="tagline">Our mission is to make shopping better with smarter savings for everyone.
                        savings!</p>
                    <div class="footer-socials">
                        <a [href]="getSocialMediaUrl('Facebook')" class="f-social fb" aria-label="Facebook"><svg
                                class="f-social-icon fb-icon" width="16" height="16" viewBox="0 0 24 24"
                                fill="currentColor" stroke="none">
                                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3.6l.4-4h-4V7a1 1 0 0 1 1-1h3z">
                                </path>
                            </svg></a>
                        <a [href]="getSocialMediaUrl('X')" class="f-social tw" aria-label="X"><svg
                                class="f-social-icon tw-icon" width="16" height="16" viewBox="0 0 24 24"
                                fill="currentColor" stroke="none">
                                <path
                                    d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z">
                                </path>
                            </svg></a>
                        <a [href]="getSocialMediaUrl('LinkedIn')" class="f-social li" aria-label="LinkedIn"><svg
                                class="f-social-icon li-icon" width="16" height="16" viewBox="0 0 24 24"
                                fill="currentColor" stroke="none">
                                <path
                                    d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z">
                                </path>
                                <rect x="2" y="9" width="4" height="12"></rect>
                                <circle cx="4" cy="4" r="2"></circle>
                            </svg></a>
                        <a [href]="getSocialMediaUrl('Instagram')" class="f-social ig" aria-label="Instagram"><svg
                                class="f-social-icon ig-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                            </svg></a>
                        <a [href]="getSocialMediaUrl('YouTube')" class="f-social yt" aria-label="YouTube"><svg
                                class="f-social-icon yt-icon" width="16" height="16" viewBox="0 0 24 24"
                                fill="currentColor">
                                <path
                                    d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                            </svg></a>
                        <a [href]="getSocialMediaUrl('Pinterest')" class="f-social pi" aria-label="Pinterest"><svg
                                class="f-social-icon pi-icon" width="16" height="16" viewBox="0 0 24 24"
                                fill="currentColor" stroke="none">
                                <path
                                    d="M12 2C6.48 2 2 6.48 2 12c0 4.25 2.66 7.9 6.44 9.34-.09-.79-.17-2.01.04-2.88.19-.8 1.25-5.3 1.25-5.3s-.32-.64-.32-1.58c0-1.48.86-2.59 1.93-2.59.91 0 1.34.68 1.34 1.5 0 .91-.58 2.27-.88 3.53-.25 1.06.53 1.92 1.58 1.92 1.9 0 3.35-2 3.35-4.89 0-2.56-1.84-4.35-4.47-4.35-3.05 0-4.85 2.29-4.85 4.66 0 .91.35 1.88.79 2.41.09.1.1.2.07.31-.08.34-.27 1.13-.31 1.28-.05.17-.18.21-.36.13-1.35-.61-2.19-2.53-2.19-4.08 0-3.32 2.41-6.37 6.96-6.37 3.65 0 6.49 2.6 6.49 6.07 0 3.63-2.29 6.55-5.46 6.55-1.07 0-2.07-.56-2.41-1.21 0 0-.53 2.01-.66 2.51-.24.93-.89 2.1-1.32 2.81A9.976 9.976 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z" />
                            </svg></a>
                    </div>
                    <p class="footer-disclosure">DealsZo may earn a small commission when you shop through our
                        links. <a href="/about-us/">Read More</a></p>
                </div>
                <!-- Company -->
                <div>
                    <h4 class="footer-col-head">Company</h4>
                    <div class="footer-links">
                        <a href="/about-us/">About Us</a>
                        <a href="/terms/">Terms of Service</a>
                        <a href="/privacy/">Privacy Policy</a>
                        <a href="/contact-us/">Contact Us</a>
                    </div>
                </div>
                <!-- Seasonal Deals -->
                <div>
                    <h4 class="footer-col-head">Seasonal Deals</h4>
                    <div class="footer-links">
                        <a *ngFor="let seasonal of seasonalEvents"
                            href="/seasonal/{{seasonal.SeasonalSEOName}}/">{{seasonal.SeasonalName}}</a>
                    </div>
                </div>
                <!-- Contact -->
                <div>
                    <h4 class="footer-col-head">Contact Us</h4>
                    <div class="footer-contact-items">
                        <div class="footer-contact-item">
                            <svg class="icon-svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                <circle cx="12" cy="10" r="3"></circle>
                            </svg>
                            <span>Dealszo<br>Suite 210, 2861 Executive Dr<br>Clearwater, Florida, Zip: 33762<br>United
                                States of America</span>
                        </div>
                        <div class="footer-contact-item">
                            <svg class="icon-svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z">
                                </path>
                                <polyline points="22,6 12,13 2,6"></polyline>
                            </svg>
                            <a href="mailto:contact@dealszo.com">{{contactMail}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr class="footer-divider">
    <div class="footer-motto">
        <div class="container">
            <h2>#BudgetSaverHub</h2>
            <p>Big Savings, Everyday Shopping</p>
        </div>
    </div>
    <div class="footer-copyright">
        <div class="container">
            <div class="footer-copyright-inner">
                <span>© Copyright {{currentYear}}. All Rights Reserved.</span>
            </div>
        </div>
    </div>
</footer>

<!-- Deal Reveal Modal -->
<!-- <div id="deal-modal" class="deal-modal-overlay">
    <div class="deal-modal-container">
        <button class="deal-modal-close" id="close-deal-modal" aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
        <div class="deal-modal-content">
            <div class="deal-brand-logo">
                <img src="images/dealszo-logo.svg" alt="DealsZo Logo" width="160" height="40">
            </div>
            <div class="deal-text-content">
                <p class="deal-subtitle">DON'T MISS THIS DEAL</p>
                <h2 class="deal-title">20% Off Sitewide</h2>
            </div>
            <button class="deal-button">
                <span>Show Code</span>
                <div class="button-sliver"></div>
            </button>
        </div>
    </div>
</div> -->

<!-- Mobile Bottom Navigation (Visible on Mobile Only) -->
<nav class="mobile-bottom-nav" aria-label="Mobile Navigation">
    <a href="/" class="mobile-bottom-item active">
        <img src="images/home-icon.svg" alt="Home Page" width="22" height="22">
        <span>Home</span>
    </a>
    <a href="/stores/" class="mobile-bottom-item">
        <img src="images/stores-icon.svg" alt="Stores Page" width="22" height="22">
        <span>Stores</span>
    </a>
    <a href="/deals/" class="mobile-bottom-item">
        <img src="images/deals-icon.svg" alt="Deals Page" width="22" height="22">
        <span>Deals</span>
    </a>
    <a href="/categories/" class="mobile-bottom-item">
        <img src="images/categories-icon.svg" alt="Categories Page" width="22" height="22">
        <span>Categories</span>
    </a>
</nav>